import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    localStorageTagsKey: 'osTags',
    numberOfPageVisitsToSendTag: 1,
  }) as const) satisfies ConfigFn

export default config
